import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import rootReducer from 'redux/rootReducer';
import loginMiddleware from 'middleware/login';
import logOutMiddleWare from 'middleware/logout';
import { LsKey, lsGet } from 'utils/localStorageUtils';

const createStore = () => {
  const middleware = [loginMiddleware, logOutMiddleWare];

  if (lsGet(LsKey.EnableReduxLogging)) {
    middleware.push(createLogger() as any);
  }

  return configureStore({
    reducer: rootReducer,
    middleware
  });
};

export default createStore;
